export default {
  "openingScreen" : {
    "message" : "學習如何使用 CrxMouse",
    "description" : "Start game screen. Sentence finishes with the words - The Mouse Chase"
  },
  "startGame" : {
    "message" : "開始遊戲",
    "description" : "Start game option - on screen 1"
  },
  "settings" : {
    "message" : "進入擴充設定頁",
    "description" : "Settings option. Don't translate the word - CrxMouse - on screen 1 and 6"
  },
  "gestureList" : {
    "message" : "手勢清單",
    "description" : "Gesture list option - on screen 1 and 6"
  },
  "playLater" : {
    "message" : "晚點再玩",
    "description" : "Play later option - on screen 1"
  },
  "playAgain" : {
    "message" : "再玩一次",
    "description" : "Play again option - on screen 6"
  },
  "startGameScreen0" : {
    "message" : "若要開始遊戲",
    "description" : "First sentence of the first screen for users that don't have CrxMouse installed - on screen 0"
  },
  "firstGestureInstructionDownload" : {
    "message" : "在 Chrome 上下載 CrxMouse",
    "description" : "CrxMouse is available on Chrome extension store. This is the CTA that sends the user to CrxMouse on Chrome. Do not translate the word - CrxMouse - on screen 0"
  },
  "firstDownloadNow" : {
    "message" : "立即下載",
    "description" : "CTA to download CrxMouse - on screen 0"
  },
  "gestureInstructions1" : {
    "message" : "使用滑鼠手勢向下捲動",
    "description" : "gesture instructions on screen 1 of the game"
  },
  "gameReference1" : {
    "message" : "*** 開始追逐 ***",
    "description" : "reference to the mouse chase game on screen 1 of the game"
  },
  "movementInstructions1" : {
    "message" : "在畫面上任意位置按住<span class='yellow-text'>滑鼠右鍵</span> + <span class='yellow-text'>向下</span>拖曳一點 + 放開右鍵",
    "description" : "movement instructions on screen 1 of the game"
  },
  "gestureInstructions2" : {
    "message" : "使用超級拖曳手勢，在新分頁中開啟連結",
    "description" : "gesture instructions on screen 2 of the game"
  },
  "gameReference2" : {
    "message" : "逃離怪物！！！",
    "description" : "reference to the mouse chase game on screen 2 of the game"
  },
  "movementInstructions2Part1" : {
    "message" : "按住<span class='yellow-text'>滑鼠左鍵</span>",
    "description" : "movement instructions on screen 1 of the game - part 1 of the sentence"
  },
  "movementInstructions2Part2" : {
    "message" : "在<a class='blue-link' href='/the-mouse-chase-2' target='_blank'>這個連結</a>上",
    "description" : "movement instructions on screen 1 of the game - part 2 of the sentence"
  },
  "movementInstructions2Part3" : {
    "message" : " + <span class='yellow-text'>向右</span>拖曳一點 + 放開左鍵",
    "description" : "movement instructions on screen 1 of the game - part 3 of the sentence"
  },
  "gestureInstructions3" : {
    "message" : "使用滑鼠手勢瀏覽左側分頁",
    "description" : "gesture instructions on screen 3 of the game"
  },
  "gameReference3" : {
    "message" : "快回頭！公主有難",
    "description" : "reference to the mouse chase game on screen 3 of the game"
  },
  "movementInstructions3" : {
    "message" : "在畫面上任意位置按住<span class='yellow-text'>滑鼠右鍵</span> + <span class='yellow-text'>向左上方</span>拖曳一點 + 放開右鍵",
    "description" : "movement instructions on screen 3 of the game"
  },
  "gestureInstructions4" : {
    "message" : "使用滑鼠手勢捲動到頁面頂端",
    "description" : "gesture instructions on screen 4 of the game"
  },
  "gameReference4" : {
    "message" : "打敗惡貓，救出公主",
    "description" : "reference to the mouse chase game on screen 4 of the game"
  },
  "movementInstructions4" : {
    "message" : "在畫面上任意位置按住<span class='yellow-text'>滑鼠右鍵</span> + <span class='yellow-text'>向右上方</span>拖曳一點 + 放開右鍵",
    "description" : "movement instructions on screen 4 of the game"
  },
  "gestureInstructions5" : {
    "message" : "使用超級拖曳手勢儲存圖片",
    "description" : "gesture instructions on screen 5 of the game"
  },
  "gameReference5" : {
    "message" : "你成功了！現在去救出公主吧",
    "description" : "reference to the mouse chase game on screen 5 of the game"
  },
  "movementInstructions5" : {
    "message" : "在公主人物上按住<span class='yellow-text'>滑鼠左鍵</span> + <span class='yellow-text'>向下</span>拖曳一點 + 放開左鍵",
    "description" : "movement instructions on screen 5 of the game"
  },
  "fifthFinishGame" : {
    "message" : "按這裡結束遊戲",
    "description" : "A CTA the user needs to click in order to finish the game."
  },
  "sixthCongratulations" : {
    "message" : "<span class='white-text'>祝賀您！</span>",
    "description" : "The last screen of the game when the user is congratualated for finishing the game."
  },
  "sixthCrxChampion" : {
    "message" : "<br>您現在是 CrxMouse 冠軍了",
    "description" : "When translating, try to find the corresponding phrase for the phrase - CrxMouse champion, without translating the word - CrxMouse."
  },
  "soundOn" : {
    "message" : "開啟音效",
    "description" : "instructions next to the sound icon when it's off"
  },
  "soundOff" : {
    "message" : "關閉音效",
    "description" : "instructions next to the sound icon when it's on"
  },
  "hearts" : {
    "message" : "玩遊戲賺愛心",
    "description" : "headline of hearts section"
  },
  "firstExistPopuptitle" : {
    "message" : "別走嘛！",
    "description" : "title of exit popup"
  },
  "firstExistPopupSubtitle" : {
    "message" : "你可以趁這個機會學習滑鼠手勢使用方式",
    "description" : "subtitle of  of exit popup"
  },
  "firstExistPopupSubSubtitle" : {
    "message" : "（順便拯救公主脫離惡貓的魔掌...)",
    "description" : "sub-subtitle of  of exit popup"
  },
  "firstExitPopupCTA1" : {
    "message" : "開始遊戲",
    "description" : "First CTA of first exit popup"
  },
  "exitPopupsCTA2" : {
    "message" : "觀看教學課程",
    "description" : "Second CTA of the exit popups"
  },
  "exitPopupsCTA3" : {
    "message" : "進入 CrxMouse 設定",
    "description" : "Third CTA of the exit popups"
  },
  "secondExistPopupCTA1" : {
    "message" : "繼續遊戲",
    "description" : "subtitle of the second exit popup"
  },
  "needHelpPopupTitle" : {
    "message" : "需要幫助嗎？",
    "description" : "Title of the 'need help' popup"
  },
  "needHelpPopupSubtitle" : {
    "message" : "觀看遊戲過程",
    "description" : "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
  },
  "needHelpPopupClose" : {
    "message" : "關閉",
    "description" : "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
  },
  "settingsIcon" : {
    "message" : "設定",
    "description" : "text next to settings icon - appears in all screens"
  },
  "secondExistPopupSubtitle" : {
    "message" : "只要再學習 $NUMBER$ 個手勢就行了",
    "description" : "subtitle of the second exit popup",
    "placeholders" : {
      "number" : {
        "content" : "$1"
      }
    }
  }
}
